import './styles.scss'
import React from 'react'

import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const TemplateAttachments = ({ selectedTemplateFiles, selectedTemplate, handleFiles }) => (
  <>
    {['application', 'image'].includes(selectedTemplateFiles?.[0].mimeType) ? (
      <figure
        className='conversation-template-editor__attachment-image'
        onClick={() => window.open(selectedTemplateFiles?.[0].urlLong, '_blank', 'noopener noreferrer')}
      >
        <img
          src={selectedTemplateFiles?.[0]?.thumb || selectedTemplateFiles?.[0].urlLong}
          alt='Attachment'
          onError={(e) => {
            if (selectedTemplateFiles?.[0].mimeType === 'application') {
              e.target.src = getStaticImage('/pdf-default.png')
            } else {
              e.target.src = getStaticImage('/image-default.png')
            }
          }}
        />
      </figure>
    ) : (
      <video
        src={selectedTemplateFiles?.[0].urlLong}
        width='178'
        height='100'
        controls
        controlsList='nodownload'
      >
        {lang('dashboard_browser-not-support-video-format')}
      </video>
    )}
    {selectedTemplate?.attachments?.[0]?.fileId !== selectedTemplateFiles?.[0]?.fileId ? (
      <button
        type='button'
        title={lang('dashboard_restore-attachment')}
        className='conversation-template-editor__icon-btn-close'
        onClick={() => handleFiles(selectedTemplate?.attachments || [])}
      >
        <figure>
          <img
            src={getStaticImage('/icons/orange-brand/sync-primary.svg')}
            alt='Close'
          />
        </figure>
      </button>
    ) : null}
  </>
)

export default TemplateAttachments
